var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import clsx from 'clsx';
import { isNil, useClasses, useLayoutProps, useProps } from '@hawkins/helpers';
import { Avatar } from '../avatar';
import { Text } from '../text';
import { useVerticalListItemStyles } from './verticalListItem.styles';
export var displayName = 'VerticalListItem';
/**
 * Vertical List Item contains a label, metadata and an Actionable Element.
 * It must be rendered inside of VerticalList.
 */
export var VerticalListItem = React.forwardRef(function (_a, ref) {
    var props = __rest(_a, []);
    // Props
    var _b = useProps(displayName, props), classesProp = _b.classes, className = _b.className, _c = _b.component, Component = _c === void 0 ? 'div' : _c, layout = _b.layout, styleProp = _b.style, label = _b.label, metadata = _b.metadata, avatarProps = _b.avatarProps, imageSrc = _b.imageSrc, icon = _b.icon, actionElement = _b.actionElement, restProps = __rest(_b, ["classes", "className", "component", "layout", "style", "label", "metadata", "avatarProps", "imageSrc", "icon", "actionElement"]);
    // Styles
    var baseClasses = useVerticalListItemStyles();
    var classes = useClasses(displayName, baseClasses, classesProp);
    var style = useLayoutProps({ layout: layout, style: styleProp });
    var rootClassName = clsx(classes.HAWKINS_BASE, className, classes.root);
    var isAvatarPresent = Boolean(imageSrc) || Boolean(avatarProps === null || avatarProps === void 0 ? void 0 : avatarProps.imageSrc);
    var isIconPresent = Boolean(icon) && React.isValidElement(icon);
    // Content
    var startAdornment;
    if (isAvatarPresent) {
        startAdornment = _jsx(Avatar, __assign({ name: label, size: "small", imageSrc: imageSrc, variant: "avatar-only" }, avatarProps));
    }
    else if (isIconPresent) {
        startAdornment = icon;
    }
    // Render
    return (_jsxs(Component, __assign({ className: rootClassName, ref: ref, style: style }, restProps, { children: [_jsxs("div", __assign({ className: classes.contentContainer }, { children: [!isNil(startAdornment) ? _jsx("span", __assign({ className: classes.adornmentContainer }, { children: startAdornment })) : null, _jsxs("div", __assign({ className: classes.textContainer }, { children: [_jsx(Text, __assign({ bold: true }, { children: label })), !isNil(metadata) ? _jsx(Text, __assign({ colorVariant: "faded" }, { children: metadata })) : null] }))] })), actionElement && _jsx("div", __assign({ className: classes.actionContainer }, { children: actionElement }))] })));
});
VerticalListItem.displayName = displayName;
